import { DEFAULT_SPORTS, DEFAULT_TYPES } from "../../../sports"

const periodDefinitions = {
  oneOf: [
    { const: 'last7days', title: 'Viimeiset 7 päivää' },
    { const: 'last30days', title: 'Viimeiset 30 päivää' },
    { const: 'last90days', title: 'Viimeiset 90 päivää' },
    { const: 'lastmonth', title: 'Edellinen kalenterikuukausi' },
    { const: 'thismonth', title: 'Tämä kalenterikuukausi' },
    { const: 'lastyear', title: 'Edellinen kalenterivuosi' },
    { const: 'thisyear', title: 'Tämä kalenterivuosi' },
    { const: 'last365days', title: 'Viimeiset 365 päivää' },
    { const: 'yeartodate', title: 'Kuluvan vuoden alusta tähän päivään' },
    { const: 'next30days', title: 'Seuraavat 30 päivää' },
    { const: 'next90days', title: 'Seuraavat 90 päivää' },
    { const: 'endofyear', title: 'Kuluvan vuoden loppuun' },
    { const: 'custom', title: 'Mukautettu aikaväli' },
  ],
}

export const _messagingListClass = {
  name: { type: 'string', title: 'Nimi' },
  // description: { type: 'string', title: 'Kuvaus' },
  sourcetype: {
    type: 'string',
    title: 'Lähde',
    oneOf: [
      { const: 'reservations', title: 'Varaukset' },
      { const: 'activities', title: 'Aktiviteetit' },
      { const: 'memberships', title: 'Jäsenyydet' },
      { const: 'eventtickets', title: 'Tapahtumaliput' },
      { const: 'benefitcards', title: 'Sarjakortit' },
      { const: 'users', title: 'Asiakkaat' },
    ],
  }
}

export const _messagingListClassDeps = {
  sourcetype: {
    oneOf: [
      {
        properties: {
          sourcetype: {
            enum: ['reservations'],
          },
          reservationstatus: {
            type: 'array',
            title: 'Varauksen tila',
            description:
              'Vakiovuoron kohdalla "varattu" tarkoittaa, että vakiovuoro on voimassa, vaikka yksittäisiä kertoja olisi peruttu.',
            items: {
              type: 'string',
              oneOf: [
                { const: 'reserved', title: 'Varattu' },
                { const: 'onsale', title: 'Myynnissä' },
                { const: 'cancelled', title: 'Peruttu' },
              ],
            },
            uniqueItems: true,
            default: ['reserved'],
          },
          reservationtype: {
            type: 'array',
            title: 'Varauksen tyyppi',
            items: {
              type: 'string',
              oneOf: [
                { const: 'single', title: 'Irtovuoro' },
                { const: 'recurring', title: 'Vakiovuoro' },
              ],
            },
            uniqueItems: true,
            default: ['single', 'recurring'],
          },
          categories: {
            type: 'array',
            title: 'Kategoriat',
            items: {
              type: 'string',
              oneOf: [
                { const: 'all', title: 'Kaikki' },
              ],
            },
            uniqueItems: true,
            description: 'Voit valita kategoriat ja/tai resurssit alla. Valinnat täydentävät toisiaan.',
          },
          resources: {
            type: 'array',
            title: 'Resurssit',
            items: {
              type: 'string',
              oneOf: [],
            },
            uniqueItems: true,
          },
          period: {
            type: 'string',
            title: 'Aikaväli',
            ...periodDefinitions,
            default: 'lastmonth',
          },
        },
        required: ['reservationstatus', 'reservationtype'],
      },
      {
        properties: {
          sourcetype: {
            enum: ['eventtickets'],
          },
          period: {
            type: 'string',
            title: 'Aikaväli',
            ...periodDefinitions,
            default: 'lastmonth',
          },
        },
        required: ['period'],
      },
      {
        properties: {
          sourcetype: {
            enum: ['benefitcards'],
          },
          benefitcardstatus: {
            type: 'array',
            title: 'Sarjakortin tila',
            items: {
              type: 'string',
              oneOf: [
                { const: 'started', title: 'Alkanut' },
                { const: 'active', title: 'Aktiivinen' },
                { const: 'validuntil', title: 'Voimassa asti' },
              ],
            },
            uniqueItems: true,
            default: ['active'],
          },
          cardcollection: {
            type: 'string',
            title: 'Kortin käyttökohde',
            oneOf: [
              { const: 'activities', title: 'Aktiviteetit' },
              { const: 'reservations', title: 'Varaukset' },
            ],
          },
          period: {
            type: 'string',
            title: 'Aikaväli',
            ...periodDefinitions,
            default: 'lastmonth',
          },
        },
        required: ['benefitcardstatus'],
      },
      {
        properties: {
          sourcetype: {
            enum: ['activities'],
          },
          activitytype: {
            type: 'array',
            title: 'Aktiviteetti tyypit',
            items: {
              type: 'string',
              oneOf: DEFAULT_TYPES.map((t) => ({ const: t.key, title: t.label })),
            },
            uniqueItems: true
          },
          activitysport: {
            type: 'array',
            title: 'Lajit',
            items: {
              type: 'string',
              oneOf: DEFAULT_SPORTS.map((s) => ({ const: s.key, title: s.label })),
            },
            uniqueItems: true,
          },
          period: {
            type: 'string',
            title: 'Aikaväli',
            ...periodDefinitions,
            default: 'lastmonth',
          },
        },
        required: ['activitytype', 'period'],
      },
      {
        properties: {
          sourcetype: {
            enum: ['memberships'],
          },
          membershipstatus: {
            type: 'array',
            title: 'Jäsenyyden tila',
            items: {
              type: 'string',
              oneOf: [
                { const: 'active', title: 'Aktiivinen' },
                { const: 'expired', title: 'Päättynyt' },
                { const: 'started', title: 'Alkanut' },
              ],
            },
            uniqueItems: true,
            default: ['active'],
          },
          membershipids: {
            type: 'array',
            title: 'Jäsenyydet',
            items: {
              type: 'string',
              oneOf: [],
            },
            uniqueItems: true,
            description: 'Voit valita jäsenyydet alla.',
          },
          period: {
            type: 'string',
            title: 'Aikaväli',
            ...periodDefinitions,
            default: 'lastmonth',
          },
        },
        required: ['membershipstatus'],
      },
      {
        properties: {
          sourcetype: {
            enum: ['users'],
          },
          userstatus: {
            type: 'string',
            title: 'Asiakkaat',
            oneOf: [
              { const: 'all', title: 'Kaikki käyttäjät' },
              { const: 'new', title: 'Uudet käyttäjät' },
            ],
            default: 'all'
          },
        },
        required: [],
      },
    ],
  },
  period: {
    oneOf: [
      {
        properties: {
          period: {
            enum: ['custom'],
          },
          startdate: {
            type: 'string',
            format: 'date',
            title: 'Alkupäivämäärä',
          },
          enddate: {
            type: 'string',
            format: 'date',
            title: 'Loppupäivämäärä',
          },
        },
        required: ['startdate', 'enddate'],
      },
    ],
  },
}

export const _messagingListUISchema = {
  reservationstatus: {
    'ui:widget': 'checkboxes',
  },
  reservationtype: {
    'ui:widget': 'checkboxes',
  },
  activitytype: {
    'ui:widget': 'checkboxes',
  },
  membershipstatus: {
    'ui:widget': 'checkboxes',
  },
  categories: {
    'ui:widget': 'checkboxes',
  },
  resources: {
    'ui:widget': 'checkboxes',
  },
  benefitcardstatus: {
    'ui:widget': 'checkboxes',
  },
  membershipids: {
    'ui:widget': 'checkboxes',
  },
}

export const _messagingListMessageClass = {
  title: { type: 'string', title: 'Aihe' },
  listids: {
    type: 'array',
    title: 'Viestilistat joille viesti lähetetään',
    items: {
      type: 'string',
      oneOf: [],
    },
    uniqueItems: true,
  },
  // sent: { type: 'string', title: 'Lähetetty' },
  status: {
    type: 'string',
    title: 'Tila',
    readOnly: true,
    oneOf: [
      { const: 'draft', title: 'Luonnos' },
      { const: 'sent', title: 'Lähetetty' },
    ],
    default: 'draft',
  },
}

export const _messagingListMessageUISchema = {
  listids: {
    'ui:widget': 'checkboxes',
  },
}
